import 'intersection-observer';
import 'url-search-params-polyfill';
import { Logger } from 'src/utils';

export default (function () {
    if (!String.prototype.includes) {
        String.prototype.includes = function (search: string, start?: number) {
            'use strict';
            if (typeof start !== 'number') {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            } else {
                return this.indexOf(search, start) !== -1;
            }
        };
    }

    if (!Array.prototype.includes) {
        Array.prototype.includes = function (search: string, start?: number) {
            'use strict';
            if (typeof start !== 'number') {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            } else {
                return this.indexOf(search, start) !== -1;
            }
        };
    }

    if (typeof Promise.prototype['finally'] !== 'function') {
        Promise.prototype['finally'] = function (callback: () => void) {
            const constructor = this.constructor;

            return this.then(
                function (value) {
                    // @ts-ignore
                    return constructor.resolve(callback()).then(function () {
                        return value;
                    });
                },
                function (reason) {
                    // @ts-ignore
                    return constructor.resolve(callback()).then(function () {
                        throw reason;
                    });
                }
            );
        };
    }

    if (!Object.values) {
        Object.values = function (obj: any) {
            const allowedTypes = [
                '[object String]',
                '[object Object]',
                '[object Array]',
                '[object Function]',
            ];
            const objType = Object.prototype.toString.call(obj);

            if (obj === null || typeof obj === 'undefined') {
                throw new TypeError(
                    'Cannot convert undefined or null to object'
                );
            } else if (!~allowedTypes.indexOf(objType)) {
                return [];
            } else {
                if (Object.keys) {
                    return Object.keys(obj).map(function (key) {
                        return obj[key];
                    });
                }

                const result: string[] = [];
                for (let prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        result.push(obj[prop]);
                    }
                }

                return result;
            }
        };
    }

    if (!Object.entries) {
        Object.entries = function (obj: any) {
            const ownProps = Object.keys(obj);
            let i = ownProps.length;
            const resArray = new Array(i); // preallocate the Array
            while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

            return resArray;
        };
    }
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild: any = Node.prototype.removeChild;
        Node.prototype.removeChild = function (child): any {
            if (child.parentNode !== this) {
                if (console) {
                    Logger.error(
                        0,
                        'Cannot remove a child from a different parent',
                        child,
                        this
                    );
                }
                return child;
            }
            return originalRemoveChild.apply(this, arguments);
        };

        const originalInsertBefore: any = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function (newNode, referenceNode): any {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    Logger.error(
                        0,
                        'Cannot insert before a reference node from a different parent',
                        referenceNode,
                        this
                    );
                }
                return newNode;
            }
            return originalInsertBefore.apply(this, arguments);
        };
    }
})();
